import React from 'react';
import {
  components as DefaultSelectComponents,
  ValueContainerProps,
} from 'react-select';
import _get from 'lodash/get';
import _has from 'lodash/has';
import Chip, { ChipSizes, ChipTypes } from '@lib/components/Chip/Chip';
import { colorToChipType } from '@lib/components/Chip/utils/colorEnum';
import styles from '../Select.module.scss';

export default function ChipColorValueContainer(
  props: ValueContainerProps,
): React.ReactElement {
  const { children, ...valueContainerProps } = props;
  const { selectProps } = valueContainerProps;
  const value = _get(selectProps, 'value');
  const isDisabled = _get(selectProps, 'isDisabled');

  if (Array.isArray(children) && _has(value, 'value')) {
    const valueColor = (_get(value, 'value') as string | undefined) || 'blue';
    // The option value is the `ColorEnum`; resolve it to its `chip-*` class.
    const fixedValueColor = colorToChipType(valueColor);
    const type = isDisabled ? ChipTypes.chipDisabled : fixedValueColor;
    return (
      // @ts-ignore
      <DefaultSelectComponents.ValueContainer
        {...valueContainerProps}
        className={styles.valueContainer}
      >
        <span className={styles.singleValueWrap}>
          <Chip
            leftIcon="circle"
            type={type}
            size={ChipSizes.smallLeftIconOnly}
          />
          {/* {children[0]} */}
          <span>{children[1]}</span>
        </span>
      </DefaultSelectComponents.ValueContainer>
    );
  }

  return (
    // @ts-ignore
    <DefaultSelectComponents.ValueContainer
      {...valueContainerProps}
      className={styles.valueContainer}
    >
      {children}
    </DefaultSelectComponents.ValueContainer>
  );
}
